import * as styledSystem from 'styled-system';
import themeGet from '@styled-system/theme-get';

import { getDefaultTheme } from './utils';

const theme = getDefaultTheme();
const { get: getKey } = styledSystem;

export const get = (key) => themeGet(key, getKey(theme, key));
